import { Box, Divider, Paragraph } from '@zillow/constellation-10';

import numberUtils from '../../../../utils/numberUtils';

type Props = {
  isWaived: boolean;
  securityDepositInputValue: number | string;
};

const RENTER_DAMAGE = 5000;
const AMT_PLACEHOLDER = '$--';
const renterDamageFormatted = numberUtils.asCurrency(RENTER_DAMAGE, '$0,0');

const SecurityDepositClaimExample = ({ isWaived, securityDepositInputValue }: Props) => {
  const isSecurityDepositNull = securityDepositInputValue === null || securityDepositInputValue === '';
  const securityDepositValOrPlaceHolder = isSecurityDepositNull
    ? AMT_PLACEHOLDER
    : numberUtils.asCurrency(Number(securityDepositInputValue), '$0,0');
  const securityDeposit = isWaived ? 'Waived' : securityDepositValOrPlaceHolder;
  const payoutOrPlaceholder =
    securityDepositValOrPlaceHolder == AMT_PLACEHOLDER
      ? AMT_PLACEHOLDER
      : numberUtils.asCurrency(RENTER_DAMAGE - Number(securityDepositInputValue), '$0,0');
  const payout = isWaived ? renterDamageFormatted : payoutOrPlaceholder;

  return (
    <Box css={{ display: 'flex', flexDirection: 'column', marginTop: '600' }} data-testid="SecurityDepositClaimExample">
      <Box css={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBlock: '200' }}>
        <Paragraph css={{ color: 'text.accent.gray.hero' }}>Example renter damage claim</Paragraph>
        <Paragraph>{renterDamageFormatted}</Paragraph>
      </Box>
      <Box css={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBlock: '200' }}>
        <Paragraph css={{ color: 'text.accent.gray.hero' }}>Your security deposit</Paragraph>
        <Paragraph data-testid="SecurityDepositClaimExample-SecurityDepositAmount">
          {isWaived ? (
            <i>{securityDeposit}</i>
          ) : (
            <p>{isSecurityDepositNull ? securityDeposit : `(${securityDeposit})`}</p>
          )}
        </Paragraph>
      </Box>
      <Divider css={{ marginBlock: '200' }} />
      <Box css={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBlock: '200' }}>
        <Paragraph>Example claim payout</Paragraph>
        <Paragraph data-testid="SecurityDepositClaimExample-PayoutAmount">
          <b>{payout}</b>
        </Paragraph>
      </Box>
    </Box>
  );
};

export default SecurityDepositClaimExample;
